module.exports = __webpack_public_path__ + "img/J-PAL_LAC_Logo_White@2x.7e4d8505.png";